import React, { useEffect, useState } from 'react';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  ModalCloseButton, Button, Box, Text, Input,
} from '@chakra-ui/react';

// Mirrors SignAndSaveModal's reveal layout (so unlocking looks like the same
// popup as the Signed badge), but with an "Input password" field instead of a
// read-only "Edit password" display.
export default function UnlockNoteModal({ isOpen, onClose, onSubmit, error = '' }) {
  const [value, setValue] = useState('');
  useEffect(() => { if (isOpen) setValue(''); }, [isOpen]);

  const submit = () => onSubmit?.(value.trim());

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Locked note</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontSize="sm" mb={3}>
            This note is signed and locked. Enter the password to make edits — your
            changes are saved as a tracked version under your name.
          </Text>
          <Text fontSize="sm" fontWeight="semibold" mb={1}>Input password</Text>
          <Input
            aria-label="Input password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
            placeholder="XXX-XXX-XXX"
            autoFocus
            fontFamily="mono"
            fontSize="xl"
            textAlign="center"
            letterSpacing="wider"
          />
          {error ? <Text color="red.500" fontSize="sm" mt={2}>{error}</Text> : null}
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>Cancel</Button>
          <Button colorScheme="blue" onClick={submit} isDisabled={!value.trim()}>Unlock to edit</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
